export default function ScreenMarker(props) {
  let { id, width, length, color } = props;
  return (
    <marker
      id={id}
      markerWidth={length}
      markerHeight={width}
      refX={length / 2}
      refY={width / 2}
      orient="auto"
    >
      <polygon
        fill={color}
        shapeRendering="geometricPrecision"
        points={
          "0 0, " +
          length / 2 +
          " 0, " +
          length / 2 +
          " " +
          width +
          ", 0  " +
          width
        }
      />
    </marker>
  );
}
